import { useBookingSummary } from '@/booking';
import { useCurrentBookingContext } from '@/booking/hooks/use-current-booking-context.hook';
import { CurrencyCode } from '@/finance/interfaces';

import { InvalidMembershipCurrencyError } from '../errors';
import { getDisloyaltyMembershipPrice } from '../utils/get-disloyalty-membership-price';

export function useCurrentBookingMembershipDiscountDetail() {
  const { bookingId, hotelReferenceId } = useCurrentBookingContext();
  const booking = useBookingSummary({ bookingId, hotelSlug: hotelReferenceId });
  const discountDetail =
    booking.data?.firstRoomStay.firstRatePlan.chargeBreakdown.discountDetail;

  // If this isn't a membership rate code, return the detail
  if (!discountDetail?.membershipRateCode) {
    return { discountDetail, includesBundledMembership: false } as const;
  }

  const currencyCode = discountDetail.amountBeforeDiscountAfterTax.currencyCode;

  // Fetch the correct membership price matching the booking currency
  const membershipPrice = getDisloyaltyMembershipPrice(
    currencyCode as CurrencyCode
  );

  // If we have a membership-bundled booking, but no membership price for this currency, throw an error.
  if (discountDetail?.membershipRateCode && !membershipPrice) {
    throw new InvalidMembershipCurrencyError(currencyCode);
  }

  return {
    discountDetail,
    membershipPrice,
    includesBundledMembership: true,
  } as const;
}
